import { render, staticRenderFns } from "./BDXStatusModalPagination.vue?vue&type=template&id=221446d0"
import script from "./BDXStatusModalPagination.vue?vue&type=script&lang=js"
export * from "./BDXStatusModalPagination.vue?vue&type=script&lang=js"
import style0 from "./BDXStatusModalPagination.vue?vue&type=style&index=0&id=221446d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports